import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import { GetApp } from '@material-ui/icons';
import { downloadDocument } from '@roc/feature-utils';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { UserAgreementService } from '../services/userAgreementService';

interface UserAgreement {
  id: number;
  version: number;
}

const userAgreementService = new UserAgreementService();

export const UserDocumentsTab = observer(() => {
  const [agreements, setAgreements] = useState<UserAgreement[]>([]);

  useEffect(() => {
    userAgreementService.listAgreements().then(response => {
      setAgreements(response.data?.data ?? []);
    });
  }, []);

  const getTitle = (agreement: UserAgreement) =>
    `End User License Agreement v${agreement.version}`;

  const handleDownload = async (agreement: UserAgreement) => {
    const response = await userAgreementService.downloadAgreementById(agreement.id);
    downloadDocument(response.data, response.headers, 'download', `${getTitle(agreement)}.pdf`);
  };

  return (
    <TableContainer component={Paper} style={{ marginTop: 16 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell><Typography variant="body1"><strong>Title</strong></Typography></TableCell>
            <TableCell style={{ width: 48 }} />
          </TableRow>
        </TableHead>
        <TableBody>
          {agreements.map(agreement => (
            <TableRow key={agreement.id}>
              <TableCell>{getTitle(agreement)}</TableCell>
              <TableCell align="right">
                <IconButton size="small" onClick={() => handleDownload(agreement)}>
                  <GetApp />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
});
